// Polyfill for Promise.withResolvers() (ES2024 feature)
if (!Promise.withResolvers) {
  Promise.withResolvers = function () {
    let resolve, reject
    const promise = new Promise((res, rej) => {
      resolve = res
      reject = rej
    })
    return { promise, resolve, reject }
  }
}

// URL.parse polyfill
if (!URL.parse) {
  URL.parse = function (url, base) {
    try {
      return base ? new URL(url, base) : new URL(url)
    } catch {
      return null
    }
  }
}
